import { StatusCodeNames, VehicleStatus } from "../../../../store/reducers/dashboard/vehicles/statuses/types";
import { IWorkDash } from "@baseTypes/service/dashboard/IWorksDashboardService";
import { useMemo } from "react";
import { flatMap, groupBy, size } from "lodash";
import { sift } from "radash";
import { Status } from "../components/WorkItem/WorkItem";

type usePreparedStatusesArgs = {
	statuses: VehicleStatus[],
	works: IWorkDash[]
}

export default ({ works, statuses }: usePreparedStatusesArgs) => {
	return useMemo(() => {
		const allStatusesArr = statuses.reduce((acc, cur) => {
			return flatMap([...acc, cur.unitIds.map(id => ({ id, color: cur.color, status: cur.status, statusCode: cur.statusCode }))])
		}, [] as { id: number, color: string, status: string, statusCode: StatusCodeNames }[])

		return works.reduce((acc, cur) => {
			const allStatusesInWork = sift(cur.unitIds.map(id => {
				return allStatusesArr.find(status => status.id === id)
			}))

			const groupedStatuses = groupBy(allStatusesInWork, 'status')

			return {
				...acc,
				[cur.workId]: Object.entries(groupedStatuses)
					.map(([name, value]) =>
						({ name: name, value: size(value), color: value[0]?.color || '', statusCode: value[0].statusCode })
					)
			}
		}, {} as Record<string, Status[]>)
	}, [statuses, works])
}